module.exports = __webpack_public_path__ + "img/publipostage-technitoit.0d06c5a2.svg";